<template>
  <div>
    <ul class="heade-value-list">
      <li
        v-for="item in dataList"
        :key="item.id"
        class="heade-value-li"
        :class="{ 'current-data': currentData === item.id }"
        :style="`cursor: ${item.cursor};`"
        @click="changeCurrent(item.id, item.cursor)"
      >
        <div class="info-title">
          <div class="title-text">
            <p>{{ item.title }}</p>
            <el-popover
              placement="top"
              width="180"
              trigger="hover"
              :content="item.popoverContent"
            >
              <div slot="reference" class="question-text"></div>
            </el-popover>
          </div>
          <div class="info-icon">
            <i class="iconfont" :class="item.icon"></i>
          </div>
        </div>
        <h5 class="info-value">
          {{ item.value }}
        </h5>
        <div class="bottom-triangle"></div>
        <div
          v-if="item.id === 18 && hasWithdraw === 1"
          class="to-cash-out"
          @click="toCashOut(1)"
        >
          去提现 <i class="to-icon">></i>
        </div>
        <div
          v-if="item.id === 18 && hasWithdraw === 2"
          class="to-cash-out"
          @click="toCashOut(2)"
        >
          分配收入 <i class="to-icon">></i>
        </div>
      </li>
    </ul>
    <div class="description">
      <span class="description_span">每日11:00更新昨日数据</span>
    </div>
    <div v-if="dataList2.length" class="filter2-box">
      <h5 v-if="type === 'money'" class="filter2-title">收支明细</h5>
      <p
        v-for="item2 in dataList2"
        :key="item2.id"
        class="filter2-li"
        :class="{ 'current-li': currentData2 === item2.id }"
        @click="changeCurrent2(item2)"
      >
        {{ item2.label }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebDataStatistics",
  props: {
    type: {
      type: String,
      default: "info",
    },
    showInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filterList1: {},
      filterList2: {
        traffic: [
          {
            id: 100,
            label: "不限",
          },
          {
            id: 101,
            label: "PC",
          },
          {
            id: 102,
            label: "H5",
          },
          {
            id: 103,
            label: "APP",
          },
        ],
        content: [
          {
            id: 104,
            label: "浏览量",
          },
          {
            id: 105,
            label: "支付订单数",
          },
          {
            id: 106,
            label: "分成收入",
          },
          {
            id: 107,
            label: "专辑页浏览量",
          },
          {
            id: 108,
            label: "专辑资料浏览量",
          },
          {
            id: 109,
            label: "专辑资料支付订单数",
          },
        ],
        money: [
          {
            id: 100,
            label: "不限",
          },
          {
            id: 110,
            label: "收益",
          },
          {
            id: 111,
            label: "支出",
          },
        ],
      },
      dataList: [], // 第一行展示的数据列表
      dataList2: [], // 第二行展示的数据筛选项
      currentData: 1, // 第一行选中展示的数据
      currentData2: 100, // 第二行选中展示的数据
    };
  },
  watch: {
    showInfo: {
      handler() {
        this.initData();
      },
      // immediate: true,
      deep: true,
    },
  },
  computed: {
    hasWithdraw() {
      return this.$store.state.user.userInfo.hasWithdraw;
    },
    // 店铺或工作室
    shopOrStudioTag() {
      return this.$store.getters["user/shopOrStudioTag"];
    },
  },
  created() {
    this.initFilterList();
  },
  mounted() {},

  methods: {
    // 初始化 filterList1，使用动态标签
    initFilterList() {
      this.filterList1 = {
        info: [
          {
            id: 1,
            title: `${this.shopOrStudioTag}收入（元）`,
            popoverTitle: `${this.shopOrStudioTag}收入`,
            popoverContent: `筛选时间段内，${this.shopOrStudioTag}各项收入的总和。`,
            icon: "icon-jine",
            value: 0,
          },
          {
            id: 2,
            title: `${this.shopOrStudioTag}浏览量`,
            popoverTitle: `${this.shopOrStudioTag}浏览量`,
            popoverContent: `筛选时间段内，${this.shopOrStudioTag}被访问的次数。`,
            icon: "icon-liulan",
            value: 0,
          },
          {
            id: 3,
            title: "支付订单数",
            popoverTitle: "支付订单数",
            popoverContent:
              "筛选时间段内，所有资料、视频累计成交订单数（包括免费内容的订单）。",
            icon: "icon-dingdan",
            value: 0,
          },
          {
            id: 4,
            title: "净增粉丝数",
            popoverTitle: "净增粉丝数",
            popoverContent: "筛选时间段内，新增粉丝数-取关粉丝数。",
            icon: "icon-jingzeng",
            value: 0,
          },
        ],
        traffic: [
          {
            id: 2,
            title: `${this.shopOrStudioTag}浏览量`,
            popoverTitle: `${this.shopOrStudioTag}浏览量`,
            popoverContent: `筛选时间段内，${this.shopOrStudioTag}被访问的次数。`,
            icon: "icon-liulan",
            value: 0,
          },
          {
            id: 5,
            title: `${this.shopOrStudioTag}访客数`,
            popoverTitle: `${this.shopOrStudioTag}访客数`,
            popoverContent: `筛选时间段内，访问${this.shopOrStudioTag}的用户数。`,
            icon: "icon-fangke",
            value: 0,
          },
          {
            id: 6,
            title: "内容浏览量",
            popoverTitle: "内容浏览量",
            popoverContent: "筛选时间段内，所有内容页面被访问的次数。",
            icon: "icon-liulan",
            value: 0,
          },
          {
            id: 7,
            title: "内容访客数",
            popoverTitle: "内容访客数",
            popoverContent: "筛选时间段内，访问所有内容页面的用户数。",
            icon: "icon-fangke",
            value: 0,
          },
        ],
        content: [
          {
            id: 8,
            title: "资料",
            popoverTitle: "资料",
            popoverContent: "截至昨天，审核通过的全部资料数量。",
            icon: "icon-ziliao",
            value: 0,
          },
          {
            id: 9,
            title: "专辑",
            popoverTitle: "专辑",
            popoverContent: "截至昨天，审核通过的全部专辑数量。",
            icon: "icon-zhuanji",
            value: 0,
          },
          {
            id: 10,
            title: "视频",
            popoverTitle: "视频",
            popoverContent: "截至昨天，审核通过的全部视频数量。",
            icon: "icon-shipin",
            value: 0,
          },
          {
            id: 11,
            title: "文章",
            popoverTitle: "文章",
            popoverContent: "截至昨天，审核通过的全部文章数量。",
            icon: "icon-wenzhang",
            value: 0,
            cursor: "not-allowed",
          },
        ],
        user: [
          {
            id: 5,
            title: `${this.shopOrStudioTag}访客数`,
            popoverTitle: `${this.shopOrStudioTag}访客数`,
            popoverContent: `筛选时间段内，访问${this.shopOrStudioTag}的用户数。`,
            icon: "icon-liulan",
            value: 0,
          },
          {
            id: 12,
            title: "新增粉丝数",
            popoverTitle: "新增粉丝数",
            popoverContent: `筛选时间段内，关注${this.shopOrStudioTag}的用户数。`,
            icon: "icon-xinzeng",
            value: 0,
          },
          {
            id: 13,
            title: "取关粉丝数",
            popoverTitle: "取关粉丝数",
            popoverContent: `筛选时间段内，取消关注${this.shopOrStudioTag}的用户数。`,
            icon: "icon-xinzeng",
            value: 0,
          },
          {
            id: 14,
            title: "净增粉丝数",
            popoverTitle: "净增粉丝数",
            popoverContent: "筛选时间段内，新增粉丝数-取关粉丝数。",
            icon: "icon-jingzeng",
            value: 0,
          },
          {
            id: 15,
            title: "累计粉丝数",
            popoverTitle: "累计粉丝数",
            popoverContent: `截至昨天，关注${this.shopOrStudioTag}的全部用户数。`,
            icon: "icon-leiji",
            value: 0,
            cursor: "not-allowed",
          },
        ],
        money: [
          {
            id: 16,
            title: `${this.shopOrStudioTag}收入`,
            popoverTitle: `${this.shopOrStudioTag}收入`,
            popoverContent: `筛选时间段内，${this.shopOrStudioTag}各项收入的总和。`,
            icon: "icon-shouru",
            value: 0,
            cursor: "auto",
          },
          {
            id: 17,
            title: "内容分成收入",
            popoverTitle: "内容分成收入",
            popoverContent: "筛选时间段内，所有内容和学科网分成后的收入总额。",
            icon: "icon-jingzeng",
            value: 0,
            cursor: "auto",
          },
          {
            id: 18,
            title: "可提现金额",
            popoverTitle: "可提现金额",
            popoverContent: `${this.shopOrStudioTag}可提现的金额。`,
            icon: "icon-jine",
            value: 0,
            cursor: "auto",
          },
        ],
      };

      // 如果已经有 showInfo 数据，立即初始化数据
      if (this.showInfo.length) {
        this.initData();
      }
    },
    // 初始化数据
    initData() {
      this.dataList = this.filterList1[this.type];
      this.dataList.forEach((item, index) => {
        item.value = this.showInfo[index];
      });
      if (this.type !== "money") {
        this.currentData = this.dataList[0].id;
      }
      this.dataList2Slice();
    },
    // 第二行筛选数据进行处理
    dataList2Slice() {
      // 如果是流量数据页面的话，第二行展示的数据需要做特殊处理
      if (this.type === "traffic") {
        if (this.currentData === 2 || this.currentData === 5) {
          this.dataList2 = this.filterList2[this.type].slice(0, 3);
        } else {
          this.dataList2 = this.filterList2[this.type] || [];
        }
      } else if (this.type === "content") {
        // 如果是内容数据页面的话，第二行展示的数据需要做特殊处理
        if (this.currentData === 9) {
          this.dataList2 = this.filterList2[this.type].slice(3);
        } else {
          this.dataList2 = this.filterList2[this.type].slice(0, 3) || [];
        }
      } else {
        this.dataList2 = this.filterList2[this.type] || [];
      }
      let label2 = "";
      // 重新设置第二行展示的数据的选中
      if (this.dataList2.length > 0) {
        this.currentData2 = this.dataList2[0].id;
        label2 = this.dataList2[0].label;
      }
      // 通知父组件切换数据
      this.$emit("changeData", {
        id1: this.currentData,
        id2: this.currentData2,
        label2: label2,
      });
    },
    // 切换第一行展示的数据
    changeCurrent(id, cursor) {
      // 不可点击 不做处理
      if (cursor === "auto" || cursor === "not-allowed") return;
      this.currentData = id;
      this.dataList2Slice();
    },
    // 切换第二行展示的数据
    changeCurrent2(item2) {
      this.currentData2 = item2.id;
      // 通知父组件切换数据
      this.$emit("changeData", {
        id1: this.currentData,
        id2: this.currentData2,
        label2: item2.label,
      });
    },
    // 去提现/收入分配
    toCashOut(type) {
      this.$emit("toCashOut", type);
    },
  },
};
</script>

<style lang="scss" scoped>
.heade-value-list {
  display: flex;
  align-items: center;
  justify-content: center;
  .heade-value-li {
    position: relative;
    width: 230px;
    height: 80px;
    padding: 10px 20px;
    margin-left: 25px;
    border-radius: 5px;
    border: 1px solid #dddfe6;
    background: #fff;
    cursor: pointer;
    &:first-child {
      margin-left: 0;
    }
    .info-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-text {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        p {
          color: #606266;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px; /* 100% */
        }
        .question-text {
          width: 16px;
          height: 16px;
          margin-left: 5px;
          background: url("../../assets/images/operateData/question-icon.png")
            no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
      .info-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        background: rgba($color: #6384f7, $alpha: 0.1);
        border-radius: 26px;
        i {
          color: #6384f7;
          font-weight: 500;
        }
      }
    }
    .info-value {
      margin-top: 16px;
      color: #3a3d4b;
      text-align: left;
      font-size: 34px;
      font-style: normal;
      font-weight: 700;
      line-height: 34px; /* 100% */
    }
    .bottom-triangle {
      display: none;
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 14px;
      height: 14px;
      background: #6384f7;
      transform: rotate(45deg);
    }
    .to-cash-out {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      position: absolute;
      bottom: 15px;
      right: 20px;
      color: #6384f7;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 12px; /* 100% */
      cursor: pointer;
      .to-icon {
        font-style: normal;
        font-weight: 400;
        margin-left: 3px;
        transform: translateY(-1px);
        // font-size: 14px;
      }
    }
  }
  .current-data {
    border: 1px solid #6384f7;
    background: #6384f7;
    .info-title {
      .title-text {
        p {
          color: #fff;
        }
        .question-text {
          background: url("../../assets/images/operateData/current-question-icon.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      .info-icon {
        background: rgba($color: #fff, $alpha: 0.2);
        i {
          color: #fff;
        }
      }
    }
    .info-value {
      color: #fff;
    }
    .bottom-triangle {
      display: block;
    }
    .to-cash-out {
      color: #fff;
    }
  }
}
.description {
  margin: 15px auto;
  text-align: center;
}
.description_span {
  font-size: 14px;
  color: #666;
}
.filter2-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  // height: 48px;
  margin-top: 65px;
  border-bottom: 1px solid #e7e7e7;
  .filter2-title {
    position: absolute;
    left: 0;
    bottom: 17px;
    color: #3a3d4b;
    font-size: 18px;
    font-weight: 600;
    line-height: 18px; /* 100% */
  }
  .filter2-li {
    padding: 8px 12px;
    color: #3a3d4b;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    border-bottom: 3px solid transparent;
    cursor: pointer;
    &:hover {
      color: #6384f7;
    }
  }
  .current-li {
    color: #6384f7;
    border-bottom: 3px solid #6384f7;
  }
}
</style>
